import { Input } from "@/components/ui/input/input";

const validateNumberInput = (input: string) => {
  const regex = /^$|^\d+$/;
  return regex.test(input);
};

export const NumberInput = ({
  value,
  onChange,
  ...props
}: React.ComponentProps<typeof Input> & {
  onChange: (value: number) => void;
}) => {
  return (
    <Input
      type="number"
      className="no-spinner"
      value={value}
      maxLength={100}
      onChange={(event) => {
        const val = event.target.value;
        if (validateNumberInput(val)) {
          onChange?.(Number(val));
        }
      }}
      {...props}
    />
  );
};
